import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { updateCoupaFilesById } from "../../service/updateCoupaFilesById";
import {
  updateCoupaFilesSuccess,
  updateCoupaFilesFailure,
} from "../reducers/drmCoupaUpdateSlice";

export function* workerUpdateCoupaFiles({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(updateCoupaFilesById, [payload, controller]);
    const message = response?.data?.message || "Coupa files updated successfully.";
    yield put(updateCoupaFilesSuccess(message));
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Unable to update Coupa files.";
    yield put(updateCoupaFilesFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmCoupaUpdateSaga() {
  yield takeLatest("drmCoupaUpdate/updateCoupaFilesStart", workerUpdateCoupaFiles);
}

export default drmCoupaUpdateSaga;
